export const removeNull = <T>(field: T | undefined | null): T | undefined => {
  return field || undefined;
};
